import { Component, HostListener  } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  title = 'Tejashree Enterprises';
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/app.component.ts